<script setup lang="ts">
import EditUserDrawer from '@/pages/erp/du/user/view/du-user-drawer.vue'
import type { UserProperties } from '@/pages/erp/du/user/db/du-user-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DUAPPROVE',
    },
})

const compNo = ref(useStorage('compNo').value)
const userNo = ref()
const cname = ref()
const depNo = ref()
const status = ref('D')

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
  { title: '姓名', key: 'cname' },
  { title: '單位', key: 'depNo' },
  { title: 'Email', key: 'userNo' },
  { title: '職稱', key: 'postNo' },
    { title: '電話', key: 'phone1' },
    { title: '使用期限', key: 'validDate' },
    { title: '狀態', key: 'status' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: usersData, execute: fetchUsers } = await useApi<any>(createUrl('/du/user/user/searchUser', {
  query: {
    compNo,
    userNo,
    cname,
    depNo,
    status,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): UserProperties[] => usersData.value.data.userPage.content)
const totalDatas = computed(() => usersData.value.data.userPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (userData: UserProperties) => {
  voData = userData
  console.log('editUser: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (userData: UserProperties) => {
    voData = userData
    console.log('copyUser: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (userData: UserProperties) => {
  await $api('/du/user/user/createUser', {
    method: 'POST',
    body: { user: userData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchUsers()
}

const updateData = async (userData: UserProperties) => {
  await $api('/du/user/user/updateUser', {
    method: 'PUT',
    body: { user: userData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchUsers()
}

  // 👉 Delete data
const deleteData = async (userData: UserProperties) => {
  const { compNo,userNo } = userData
    $swal({
    title: `確定要刪除 ${userData.userNo} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消"
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/du/user/user/deleteUser`, {
        method: 'DELETE',
        query: {
          compNo,userNo
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchUsers()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="userNo"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="帳號"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="cname"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="姓名"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppInput
            v-model="depNo"
            label="部門代碼"
            type="select"
            :remoteItem="duDepartmentSelect"
            item-title="label"
            item-value="value"
            placeholder="請輸入部門代碼"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增使用者資料
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.userNo="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.userNo }}
          </div>
      </template>

      <template #item.postNo="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ toText(item.postNo) }}
          </div>
      </template>

      <template #item.depNo="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                  {{ toCode(item.depNo) }}
              </div>
              <div class="text-sm">
                  {{ toText(item.depNo) }}
              </div>
          </div>
      </template>

      <template #item.cname="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.cname }}
          </div>
      </template>

      <template #item.email="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.email }}
          </div>
      </template>

      <template #item.validDate="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.validDate }}
          </div>
      </template>
      <template #item.status="{ item }">
        <div class="text-body-1 text-high-emphasis text-capitalize">
          <div class="font-weight-medium ">
            {{ toCode(item.status) }}
          </div>
          <div class="text-sm">
            {{ toText(item.status) }}
          </div>
        </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
        <VBtn
                icon
                variant="text"
                color="medium-emphasis"
        >
          <VIcon icon="tabler-dots-vertical" />
        </VBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditUserDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :user-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
